// API Client
//
// This module provides the public interface for all data access.
// Currently it delegates to the mock-api-service (client-side IndexedDB).
// TODO: Replace mock-api-service calls with authenticated HTTP requests
//       when the real REST API backend is introduced.
import { inventory as mockInventory, refills as mockRefills, saltLevels as mockSaltLevels, insights as mockInsights, data as mockData } from '../mock-api-service/index';
export const inventory = {
    list: () => mockInventory.list(),
    create: (quantityBags, status, dateArrived) => mockInventory.create(quantityBags, status, dateArrived),
    update: (item) => mockInventory.update(item),
    remove: (id) => mockInventory.remove(id),
    arrive: (id, arrivalDate) => mockInventory.arrive(id, arrivalDate),
};
export const refills = {
    list: () => mockRefills.list(),
    create: (blocks, date) => mockRefills.create(blocks, date),
    remove: (id) => mockRefills.remove(id),
};
export const saltLevels = {
    list: () => mockSaltLevels.list(),
    latest: () => mockSaltLevels.latest(),
    report: (percentage, date) => mockSaltLevels.report(percentage, date),
    remove: (id) => mockSaltLevels.remove(id),
    clearAll: () => mockSaltLevels.clearAll(),
};
export const insights = {
    forecast: () => mockInsights.getForecast(),
    inventoryStats: () => mockInsights.getInventoryStats(),
    refillStats: () => mockInsights.getRefillStats(),
    chartData: (bin) => mockInsights.getChartData(bin),
};
export const data = {
    exportAll: () => mockData.exportAll(),
    importAll: (payload, mode) => mockData.importAll(payload, mode),
};
